module.exports = "../dist/img/product-detail-3-25.070c.jpg";